<template>
  <div class="contain">
    <div class="head-title bg-white">
      <div style="margin-bottom:6px">活动名称：{{ detail.couponName }}</div>
      <div>优惠码：{{ detail.couponCode }}</div>
    </div>
    <section class="f-b-c">
      <div>
        <div>占用中</div>
        <div class="num">{{ detail.occupiedNum }} 张</div>
      </div>
      <div>
        <div>已使用</div>
        <div class="num">{{ detail.usedNum||0 }} 张</div>
      </div>
      <div>
        <div>订单金额</div>
        <div class="num">$ {{ detail.ordersTotalAmount||0 }}</div>
      </div>
      <div>
        <div>优惠金额</div>
        <div class="num">$ {{ detail.discountTotalAmount||0 }}</div>
      </div>
      <div>
        <div>平均客单价</div>
        <div class="num">$ {{ detail.orderTotalPrice||0 }}</div>
      </div>
    </section>
    <div class="bg-white main-box">
      <el-tabs v-model="active" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0" />
        <el-tab-pane label="已使用" name="2" />
        <el-tab-pane label="占用中" name="1" />
      </el-tabs>
      <div class="search">
        <el-input style="width:240px" placeholder="邮箱/手机号" v-model="userEmails" @blur="handleBlur('userEmails')" />
        <el-input style="width:240px" placeholder="订单号" v-model="kkOrderIds" @blur="handleBlur('kkOrderIds')" />
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="handleDate">
        </el-date-picker>
      </div>
      <div class="list">
        <el-table
          v-loading="loading"
          :data="list"
          height="100%"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            prop="kkOrderId"
            label="订单号">
          </el-table-column>
          <el-table-column
            prop="userEmail"
            label="邮箱/手机号">
          </el-table-column>
          <el-table-column
            prop="useStatus"
            label="使用状态">
            <template slot-scope="{row}">
              {{ row.useStatus === 1 ? '占用中' : '已使用' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="paymentStatus"
            label="支付状态">
            <template slot-scope="{row}">
              {{ row.paymentStatus === 1 ? '待付款' : '已付款' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="orderTime"
            label="下单时间">
            <template slot-scope="{row}">
              <div v-if="row.orderTime">{{ row.orderTime | dateFormat }}</div>
              <div v-else>{{ row.orderTime }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="productNum"
            label="商品数量">
          </el-table-column>
          <el-table-column
            prop="discountAmount"
            label="优惠码抵扣金额">
          </el-table-column>
          <el-table-column
            prop="transactionAmount"
            label="成交金额">
          </el-table-column>
        </el-table>
      </div>
      <footer>
        <el-pagination
          background
          :current-page="parameter.pageNumber"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="parameter.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </footer>
    </div>
  </div>
</template>

<script>
import API from '@/api';
import _ from 'lodash';
import moment from 'moment';
export default {
  data() {
    return {
      detail: {},
      loading: false,
      list: [],
      total: 0,
      active: '0',
      date: [],
      userEmails: undefined,
      kkOrderIds: undefined,
      parameter: {
        pageNumber: 1,
        pageSize: 20,
        userEmails: undefined,
        kkOrderIds: undefined,
        useStatus: undefined
      }
    }
  },
  created() {
    this.getCouponDetail()
  },
  mounted() {
  },
  methods: {
    handleClick(tab) {
      this.parameter.useStatus = tab.name === '0' ? undefined : tab.name
      this.resetPage()
    },
    handleDate(e) {
      this.parameter.orderTimeStart = e ? moment(e[0]+' 00:00:00').valueOf() : undefined
      this.parameter.orderTimeEnd = e ? moment(e[1]+' 23:59:59').valueOf() : undefined
      this.resetPage()
    },
    handleBlur(type) {
      if (type === 'userEmails') {
        this.parameter[type] = this[type] ? this[type].split(/,/) : undefined
      }else{
        this.parameter[type] = this[type] ? this[type].split(/,|\s+/) : undefined
      }
      this.resetPage()
    },
    getCouponDetail() {
      API.getCouponDetail(this.$route.query.id).then(({ data }) => {
        data.orderTotalPrice = _.round((data.ordersTotalAmount||0) / (data.usedNum||0), 2)
        this.detail = data
        this.parameter.couponCode = data.couponCode
        this.resetPage()
      })
    },
    getList() {
      this.loading = true
      API.getCouponOrderList(this.parameter).then(({ data }) => {
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.loading = false
      })
    },
    resetPage() {
      this.parameter.pageNumber = 1
      this.getList()
    },
    handleSizeChange(size) {
      this.parameter.pageSize = size
      this.getList()
    },
    handleCurrentChange(page) {
      this.parameter.pageNumber = page
      this.getList()
    },
  },
};
</script>

<style lang="scss" scoped>
.contain {
  min-width: 1400px;
  .head-title{
    padding: 20px;
    font-size: 22px;
  }
  section {
    margin-top: 12px;

    >div{
      background-color: #fff;
      width: 19%;
      box-sizing: border-box;
      padding: 20px;
    }
    .num{
      font-size: 24px;
    }
  }
  .main-box {
    padding: 4px 10px;
    margin-top: 12px;
    .search {
      >div{
        margin-right: 20px;
      }
    }
    .list{
      margin-top: 10px;
      height: calc(100vh - 470px);
    }
    footer{
      padding: 10px 0;
      display: flex;
      justify-content: flex-end;
    }
  }
}
</style>